<template>
  <div>
    <v-snackbar color="red accent-2" v-model="snackbar" top="top">
      {{ text }}

      <template v-slot:action="{ attrs }">
        <v-btn color="white" text v-bind="attrs" @click="snackbar = false">
          Close
        </v-btn>
      </template>
    </v-snackbar>
    <h1>Report</h1>
    <div class="d-flex" style="gap: 20px;">
      <v-card
        flat
        class="my-5 pa-3"
        style="border-radius: 20px; "
        color="#E9F4F5"
        @click="openDialog('Hasil Lelang')"
      >
        <div class="d-flex">
          <v-icon
            class="px-3"
            color="#c90000"
            style="background-color: white; border-radius: 10px"
            >mdi-chart-arc</v-icon
          >
          <v-card-text style="font-weight: 600">Hasil Lelang</v-card-text>
        </div>
      </v-card>

      <v-card
        flat
        class="my-5 pa-3"
        style="border-radius: 20px; max-height: 90px;"
        color="#E9F4F5"
        @click="openDialog('Jumlah Klik')"
      >
        <div class="d-flex">
          <v-icon
            class="px-3"
            color="#c90000"
            style="background-color: white; border-radius: 10px"
            >mdi-cursor-pointer</v-icon
          >
          <v-card-text style="font-weight: 600">Jumlah Klik</v-card-text>
        </div>
      </v-card>
    </div>

    <v-dialog v-model="loading" width="300" persistent>
      <div>
        <v-card-title class="white--text" style="place-content: center;"
          >Mengambil Data</v-card-title
        >
        <v-progress-linear
          indeterminate
          rounded
          height="10"
          color="white"
        ></v-progress-linear>
      </div>
    </v-dialog>
    <v-dialog v-model="dialogJumlahKlik" width="800">
      <v-card class="mt-10 pa-5">
        <div class="d-flex justify-space-between align-center py-2">
          <h4>Pilih Rentang Tanggal (Report Jumlah Klik)</h4>
          <v-icon @click="(dialogJumlahKlik = false)"
            >mdi-close</v-icon
          >
        </div>
        <v-divider class="my-3"></v-divider>
        <div class="d-flex" style="gap:20px">
          <v-menu
            v-model="menu"
            :close-on-content-click="false"
            :nudge-right="40"
            transition="scale-transition"
            offset-y
            min-width="auto"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                outlined
                dense
                v-model="startDate"
                label="Start Date"
                prepend-inner-icon="mdi-calendar"
                readonly
                hide-details
                v-bind="attrs"
                v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker
              v-model="startDate"
              @input="menu = false"
            ></v-date-picker>
          </v-menu>
          <v-menu
            v-model="menu2"
            :close-on-content-click="false"
            :nudge-right="40"
            transition="scale-transition"
            offset-y
            min-width="auto"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                outlined
                dense
                v-model="endDate"
                label="End Date"
                hide-details
                prepend-inner-icon="mdi-calendar"
                readonly
                v-bind="attrs"
                v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker
              v-model="endDate"
              :min="startDate"
              :max="calculateMaxDate(startDate)"
              @input="menu2 = false"
            ></v-date-picker>
          </v-menu>
        </div>

        <v-btn
          class="mt-4"
          :loading="loading"
          block
          color="primary"
          @click="(namaFile = 'Activity'), getReport()"
          >Get report</v-btn
        >
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogReport" width="600px" @input="resetFilter">
      <v-card class="pa-4">
        <div class="d-flex justify-space-between align-center py-2">
          <h4>Unduh Laporan {{ currentReport }}</h4>
          <v-icon @click="(dialogReport = false), resetFilter()"
            >mdi-close</v-icon
          >
        </div>
        <v-divider class="my-3"></v-divider>
        <h4>Pilih Cabang</h4>
        <v-radio-group
          hide-details
          dense
          class="pa-3 ma-0"
          v-model="selectedBranch"
          style="max-height: 400px; overflow: auto"
        >
          <label class="my-1 d-flex align-center">
            <v-radio :value="0" class="ma-0" color="#c90000"> </v-radio>
            <div>Semua</div>
          </label>
          <label
            v-for="(item, index) in listBranch"
            :key="index"
            class="my-1 d-flex align-center"
          >
            <v-radio :value="item.id" class="ma-0" color="#c90000"> </v-radio>
            <div>{{ item.nama }}</div>
          </label>
        </v-radio-group>
        <div class="py-5">
          <v-row>
            <v-col>
              <v-btn
                text
                block
                color="error"
                style="font-weight: 600"
                @click="resetFilter()"
              >
                Reset
              </v-btn>
            </v-col>
            <v-col>
              <v-btn
                depressed
                block
                :disabled="selectedBranch == null"
                class="white--text"
                color="#c90000"
                style="font-weight: 600"
                @click="(dialogDate = true), (dialogReport = false)"
              >
                Selanjutnya
              </v-btn>
            </v-col>
          </v-row>
        </div>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogDate" width="600px" @input="resetFilter">
      <v-card class="pa-4">
        <div class="d-flex justify-space-between align-center py-2">
          <h4>Pilih Rentang Tanggal</h4>
          <v-icon @click="(dialogDate = false), resetFilter()"
            >mdi-close</v-icon
          >
        </div>
        <v-divider class="my-3"></v-divider>
        <div>
          <v-menu
            ref="menuAwal"
            v-model="menuTanggalAwal"
            transition="scale-transition"
            offset-x
            min-width="290"
            :close-on-content-click="false"
          >
            <template v-slot:activator="{ on }">
              <v-card
                v-on="on"
                outlined
                class="pa-2 d-flex align-center justify-space-between mb-4"
              >
                <div>Tanggal Awal</div>
                <div style="color: #667085">
                  {{ pickTanggalAwal ? pickTanggalAwal : 'Pilih Tanggal' }}
                  <v-icon>mdi-chevron-right</v-icon>
                </div>
              </v-card>
            </template>

            <v-date-picker
              v-model="pickTanggalAwal"
              :max="
                new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
                  .toISOString()
                  .substr(0, 10)
              "
            >
              <v-spacer></v-spacer>
              <v-btn
                text
                color="red"
                @click="(menuTanggalAwal = false), (pickTanggalAwal = null)"
              >
                Batalkan
              </v-btn>
              <v-btn
                text
                color="#c90000"
                @click="$refs.menuAwal.save(pickTanggalAwal)"
              >
                Simpan
              </v-btn>
            </v-date-picker>
          </v-menu>
          <v-menu
            ref="menuAkhir"
            v-model="menuTanggalAkhir"
            transition="scale-transition"
            offset-x
            min-width="290"
            :close-on-content-click="false"
          >
            <template v-slot:activator="{ on }">
              <v-card
                v-on="on"
                outlined
                class="pa-2 d-flex align-center justify-space-between"
              >
                <div>Tanggal Akhir</div>
                <div style="color: #667085">
                  {{ pickTanggalAkhir ? pickTanggalAkhir : 'Pilih Tanggal' }}
                  <v-icon>mdi-chevron-right</v-icon>
                </div>
              </v-card>
            </template>

            <v-date-picker
              v-model="pickTanggalAkhir"
              :min="pickTanggalAwal"
              :max="
                new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
                  .toISOString()
                  .substr(0, 10)
              "
            >
              <v-spacer></v-spacer>
              <v-btn
                text
                color="red"
                @click="(menuTanggalAkhir = false), (pickTanggalAkhir = null)"
              >
                Batalkan
              </v-btn>
              <v-btn
                text
                color="#c90000"
                @click="$refs.menuAkhir.save(pickTanggalAkhir)"
              >
                Simpan
              </v-btn>
            </v-date-picker>
          </v-menu>
        </div>

        <div class="py-5">
          <v-row>
            <v-col>
              <v-btn
                text
                block
                color="error"
                style="font-weight: 600"
                @click="resetFilter()"
              >
                Reset
              </v-btn>
            </v-col>
            <v-col>
              <v-btn
                depressed
                block
                :disabled="!pickTanggalAwal || !pickTanggalAkhir"
                class="white--text"
                color="#c90000"
                style="font-weight: 600"
                @click="(namaFile = 'Hasil_lelang'), getDownloadHasilLelang()"
              >
                Unduh Laporan
              </v-btn>
            </v-col>
          </v-row>
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
export default {
  data() {
    return {
      snackbar: false,
      text: '',
      loading: false,
      menu: false,
      menu2: false,
      startDate: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
        .toISOString()
        .substr(0, 10),
      endDate: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
        .toISOString()
        .substr(0, 10),
      dialogReport: false,
      dialogDate: false,
      dialogJumlahKlik: false,
      selectedBranch: null,
      menuTanggalAwal: false,
      menuTanggalAkhir: false,
      pickTanggalAkhir: null,
      pickTanggalAwal: null,
      currentReport: null,
      listBranch: [],
      namaFile: null
    };
  },
  created() {
    this.getBranch();
  },
  methods: {
    ...mapActions({
      setAlert: 'alert/set'
    }),
    resetFilter() {
      this.selectedBranch = null;
      this.selectedType = null;
      this.pickTanggalAkhir = null;
      this.pickTanggalAwal = null;
      this.pickTanggalAwalTiket = null;
      this.pickTanggalAkhirTiket = null;
    },
    openDialog(param) {
      this.currentReport = param;
      if (param == 'Jumlah Klik') {
        this.dialogJumlahKlik = true;
      } else {
        this.dialogReport = true;
      }
    },
    async getBranch() {
      await this.$req
        .get(this.$root.$baseapi.user + '/user/v3/user/cabang', {
          params: {
            id_company: 1,
            limit: 100
          }
        })
        .then(response => {
          let { data } = response.data;
          this.listBranch = data;
          // console.log(this.listBranch)
        })
        .catch(error => {
          let responses = error.response.data;
          console.log(responses.api_message);
        });
    },
    async getDownloadHasilLelang() {
      // this.loading = true
      this.loading = true;
      let formData = new FormData();
      if (this.selectedBranch != null) {
        formData.set('id_penjual', this.selectedBranch);
      }
      formData.set('date_start', this.pickTanggalAwal);
      formData.set('date_end', this.pickTanggalAkhir);
      formData.set('id_company', 1);

      await this.$req
        .post(
          this.$root.$baseapi.report + '/report/v3/report_hasil_lelang',
          formData,
          {
            headers: { Authorization: this.DataToken }
          }
        )
        .then(response => {
          let data = response.data;
          if (!response.data.fileurl) {
            this.setAlert({
              status: true,
              color: 'error',
              text: 'Tidak terdapat laporan terkait'
            });
            this.loading = false;
          } else {
            this.downloadFile(data.fileurl);
          }
        })
        .catch(error => {
          let responses = error.response.data;
          this.setAlert({
            status: true,
            color: 'error',
            text: responses.api_message
          });
          console.log(responses.api_message);
        });
    },
    calculateMaxDate(startDate) {
      // Create a new Date object based on startDate
      let maxDate = new Date(startDate);

      // Add 30 days to maxDate
      maxDate.setDate(maxDate.getDate() + 30);

      // Format maxDate as YYYY-MM-DD (toISOString().substr(0, 10))
      return maxDate.toISOString().substr(0, 10);
    },
    getReport() {
      this.loading = true;
      let formData = new FormData();
      if (this.namaDownload != 'user') {
        formData.append('date_start', this.startDate + ' 00:00:00');
        formData.append('date_end', this.endDate + ' 23:59:00');
      }
      this.$req
        .post(
          this.$root.$baseapi.report + '/report/v3/report_activity',
          formData,
          {
            headers: { Authorization: this.DataToken }
          }
        )
        .then(response => {
          let data = response.data;
          if (response.data.fileurl == '') {
            this.color.snackbar = 'error';
            this.message = 'Data kosong';
            this.snackbar = true;
          } else {
            this.downloadFile(data.fileurl);
          }
          console.log('report user', response.data.fileurl);
        })
        .catch(error => {
          this.color.snackbar = 'error';
          this.message = error.response.data.api_message;
          this.snackbar = true;
        });
    },
    async downloadFile(filename) {
      await this.$req
        .get(this.$root.$baseapi.report + '/report/download/' + filename, {
          headers: { Authorization: this.DataToken },
          responseType: 'arraybuffer'
        })
        .then(response => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement('a');
          link.href = url;
          if (this.namaDownload == 'user') {
            link.setAttribute(
              'download',
              '[' + this.date + ']' + ' Report.zip'
            );
          } else {
            link.setAttribute(
              'download',
              this.namaFile +
                ' [' +
                this.startDate +
                ']' +
                ' sampai ' +
                '[' +
                this.endDate +
                ']' +
                ' Report.zip'
            );
          }
          document.body.appendChild(link);
          link.click();
          this.download = true;
          this.loading = false;
          setTimeout(() => {
            this.download = false;
          }, 2000);
        })
        .catch(error => {
          let responses = error.response.data;
          console.log(responses.api_message);
        });
    },
    async downloaded() {
      console.log('downloaded', this.download);
    }
  }
};
</script>

<style>
.v-dialog {
  box-shadow: none !important;
}
</style>
